<template>
  <div class="checkedlist">
    <div class="header">
      <span>
        <span>{{$t('pc_biz_signup_lbl_checked').d('已选')}}{{checkedList.length ? `：${checkedList.length}`:'：0'}}</span>
        <span v-if="limit > 0" style="color: #999"> /{{limit}}</span>
      </span>
      <yxt-button type="text" @click="clearAll" v-if="showClearAllBtn">{{$t('pc_biz_labelling_clearall').d('清空')}}</yxt-button>
    </div>
    <main class="checkedlist-main">
      <div class="checkedlist-main-placeholder" v-if="!showClearAllBtn">{{$t('biz_udp_please_select').d('请选择')}}...</div>
      <div class="group-main">
        <div class="group-main-content">
          <yxt-tag
            v-for="(item, key) in checkedList.slice(0, showCount)"
            :key="key"
            class="mr5"
            size="small"
            type="info"
            :disableTransitions="true"
            style="margin-bottom: 8px;max-width: 100%;"
            closable
            @close="deleteItem(item)"
          >
            <span class="checkedlist-tag">
              <span>
                <yxt-tooltip  class="item" effect="dark" placement="top">
                  <template slot="content">
                    <span>
                      <yxtbiz-user-name :name="item.fullname" />
                    </span>
                  </template>
                  <span>
                    <yxtbiz-user-name :name="item.fullname" />
                  </span>
                </yxt-tooltip>
              </span>
            </span>
          </yxt-tag>
          <div v-if="showCount < checkedList.length">
            <yxt-tag
              class="mr5"
              size="small"
              type="info"
              :disableTransitions="true"
              style="margin-bottom: 8px;cursor: pointer;"
              @click="() => { showCount += 50; }"
              >
                <span class="checkedlist-tag">{{$t('biz_pc_expand_more').d('展开更多')}}</span>
                <i class="yxt-icon-arrow-down" style="margin-left: 6px;"></i>
            </yxt-tag>
          </div>
          <div v-if="checkedList.length > 6 && showCount >= checkedList.length">
            <yxt-tag
              class="mr5"
              size="small"
              type="info"
              :disableTransitions="true"
              style="margin-bottom: 8px;cursor: pointer;"
              @click="() => { showCount = 6 }"
              >
                <span class="checkedlist-tag">{{$t('app_common_yxt_btn_close').d('收起')}}</span>
                <i class="yxt-icon-arrow-up" style="margin-left: 6px;"></i>
            </yxt-tag>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    limit: {
      // 限制数量，0为不限制
      type: Number,
      default: 0
    },
    checkedData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showCount: 6,
      checkedList: []
    };
  },
  computed: {
    showClearAllBtn() {
      return this.checkedList.length > 0;
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    deleteItem(item) {
      const data = this.checkedList;
      const newData = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].id !== item.id) {
          newData.push(data[i]);
        }
      }
      this.checkedList = newData;
      // this.$emit('change', item);
      this.$emit('change', { type: '', deleteItem: item });
    },
    clearAll() {
      this.checkedList = [];
      this.$emit('change', { type: 'all', deleteItem: {}});
    }
  },
  created() {
    // this.checkedList = this.transformData(this.checkedData);
    this.checkedList = this.checkedData || [];
  },
  watch: {
    checkedData: {
      deep: true,
      handler(result) {
        // this.checkedList = this.transformData(result);
        this.checkedList = result || [];
        console.log(this.checkedList, 'this.checkedList');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .checkedlist {
    padding: 24px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .header {
      display: flex;
      padding-bottom: 16px;
      justify-content: space-between;
      > span {
        font-weight: 500;
        color: #262626;
        line-height: 22px;
      }
    }
    .checkedlist-main {
      flex: 1;
      height: 100%;
      padding-right: 24px;
      margin-right: -24px;
      overflow: auto;
      .checkedlist-main-placeholder {
        color: #bfbfbf;
        font-size: 14px;
      }
    }
    .group-main {
      margin-bottom: 16px;
      &-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #595959;
        line-height: 22px;
        margin-bottom: 8px;
      }
      &—content {
        display: flex;
        justify-content: space-around;
      }
    }
    .checkedlist-tag{
      text-overflow: ellipsis;
      flex: 1 1 auto;
      overflow: hidden;
    }
  }
</style>
